// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__P3_V5","modalcontent":"Modal_modalcontent__ZpXxT"};